import { render } from "./KnowledgeResourceAdmin.vue?vue&type=template&id=57930d7b&scoped=true"
import script from "./KnowledgeResourceAdmin.vue?vue&type=script&lang=js"
export * from "./KnowledgeResourceAdmin.vue?vue&type=script&lang=js"

import "./KnowledgeResourceAdmin.vue?vue&type=style&index=0&id=57930d7b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57930d7b"]])

export default __exports__